import { render, staticRenderFns } from "./MdtfAddO.vue?vue&type=template&id=a2c34830&scoped=true&"
import script from "./MdtfAddO.vue?vue&type=script&lang=js&"
export * from "./MdtfAddO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c34830",
  null
  
)

export default component.exports